/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
} from 'react-bootstrap';
import 'react-rangeslider/lib/index.css';
import Slider from 'react-rangeslider';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { callAPI } from 'lorautils/api';
import Toolbar from 'loracoms/Toolbar';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
};

class CapacityCalculationView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      packetRatePerHour: 1.0,
      spreadFactor: 7,
      payload: 40,
      channel: 8,
      calculation: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.CapacityCalculationView');
  }

  componentDidMount() {
    this.doCalculation();
  }

  handleOnChange(value, key) {
    if (!this.state.calculation) {
      const d = {};
      let v = value;
      if (key === 'packetRatePerHour') {
        v = parseFloat(value).toFixed(1);
      }
      d[key] = v;
      this.setState(d);
      this.doCalculation();
    }
  }

  doCalculation() {
    const {
      packetRatePerHour,
      spreadFactor,
      payload,
      channel,
      calculation,
    } = this.state;
    if (!calculation) {
      this.setState({
        calculation: true,
      });
      callAPI({
        endpoint: '/na/network_capacity_calculation',
        query: {
          packet_hourly_rate: packetRatePerHour,
          spead_factor: spreadFactor,
          payload,
          channel_number: channel,
        },
      }).then((data) => {
        this.setState({
          distance: data,
          calculation: false,
        });
      });
    }
  }

  renderToolbar() {
    const title = (<div>{this.intlMsg.msg('title')}</div>);
    return (<Toolbar
      brandTitle={title}
    />
    );
  }

  renderSilider(value, name, min, max, unit, step) {
    return (
      <div>
        <Row>
          <Col md={12}>
            {this.intlMsg.msg(name)}
            <div className="pull-right">
              {this.state[name]}&nbsp;
              {unit}
            </div>
          </Col>
        </Row>
        <Slider
          className={styles.slider}
          min={min}
          max={max}
          value={value}
          step={step}
          format={p => p + unit}
          onChange={e => this.handleOnChange(e, name)}
          onChangeComplete={() => { this.doCalculation(); }}
        />
      </div>
    );
  }

  render() {
    const {
      packetRatePerHour,
      spreadFactor,
      payload,
      channel,
      distance,
    } = this.state;
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Panel bsStyle="aisz-white" header={''}>
              {this.renderSilider(packetRatePerHour, 'packetRatePerHour', 0.1, 60, '', 0.1)}
              {this.renderSilider(spreadFactor, 'spreadFactor', 7, 12, '', 1)}
              {this.renderSilider(payload, 'payload', 0, 255, 'Bytes', 1)}
              {this.renderSilider(channel, 'channel', 1, 32, '', 1)}
            </Panel>
          </Col>
          <Col md={6}>
            <Panel bsStyle="aisz-white" header={''}>
              <Row>
                <Col md={12}>
                  <h3>
                    {this.intlMsg.msg('description.heading')}&nbsp;
                  </h3>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className={styles.distanceText}>
                    {distance}&nbsp;
                  </div>
                </Col>
              </Row>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

CapacityCalculationView.propTypes = propTypes;

export default injectIntl(CapacityCalculationView);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/CapacityCalculationView/index.jsx